import { cn } from '~/lib/utils';

export type HeadingProps = {
  tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  size: 'h1' | 'h2' | 'h3' | 'custom';
  children: React.ReactNode;
  className?: string;
};

export function Heading({ size, children, className, tag }: HeadingProps) {
  const Tag = tag;
  return (
    <Tag
      className={cn(
        'font-bold',
        {
          'text-4xl text-red-600': size === 'h1', // don't know sizing for this yet
          'text-xl leading-6 md:text-2xl md:leading-7': size === 'h2',
          'text-lg leading-5 md:text-xl md:leading-6': size === 'h3',
        },
        className,
      )}
    >
      {children}
    </Tag>
  );
}
